import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';

import {
  DadosSolicitante,
  DadosUnidade,
  FormularioCompleto,
  IdentificacaoAtendimento,
  FormularioServicoComArquivos,
} from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';
import { ServicoDefaultPage } from '../../../components/servico-default-page';

@Component({
  selector: 'app-solicitar-servico',
  templateUrl: './solicitar-servico.component.html',
  styleUrls: ['./solicitar-servico.component.css'],
})
export class SolicitarServicoComponent
  extends ServicoDefaultPage
  implements OnInit, OnDestroy {
  dadosUnidade?: DadosUnidade;
  dadosSolicitante?: DadosSolicitante;

  origem: string = 'online';

  constructor(
    private route: ActivatedRoute,
    private messageService: MessageService,
    servicoService: ServicoService,
    router: Router
  ) {
    super(servicoService, router);
  }

  ngOnInit(): void {
    const slug = this.route.snapshot.paramMap.get('slug')!;
    this.getServico(slug);

    this.route.queryParams.subscribe((params) => {
      if (params['origem']) {
        this.origem = params['origem'];
      }
    });
  }

  ngOnDestroy(): void {
    this._subscriptions.forEach((s) => s.unsubscribe());
  }

  putDadosUnidade(dados: DadosUnidade) {
    this.dadosUnidade = dados;

    if (this.servico && dados.mensagemMatricula)
      this.servico.mensagemMatricula = dados.mensagemMatricula;
  }

  putDadosSolicitante(dados: DadosSolicitante) {
    this.ACTIVE_INDEX = 1;
    this.dadosSolicitante = dados;
  }

  limparDadosUnidade() {
    this.dadosUnidade = undefined;
    this.ACTIVE_INDEX = 0;
  }

  concluirCadastro(dados: FormularioServicoComArquivos) {
    this.loading = true;
    let formulario: FormularioCompleto = {
      municipioId: this.dadosSolicitante?.municipioId,
      endereco: this.dadosSolicitante?.endereco,
      complementoEndereco: this.dadosSolicitante?.complementoEndereco,
      bairro: this.dadosSolicitante?.bairro,
      servicoId: this.servico?.id,
      tipoUsuario: this.dadosSolicitante?.tipoUsuario,

      nomeSolicitante: this.dadosSolicitante?.nomeSolicitante,
      cpfSolicitante: this.dadosSolicitante?.cpfSolicitante,
      emailSolicitante: this.dadosSolicitante?.emailSolicitante,
      telefoneSolicitante: this.dadosSolicitante?.telefoneSolicitante,

      matricula: this.dadosUnidade?.matricula,
      digitoMatricula: this.dadosUnidade?.digitoVerificador,
      tipoUsuarioUnidade: this.dadosUnidade?.tipoUsuarioUnidade,
      cpfCnpjUnidade: this.dadosUnidade?.cpfCnpjUnidade,
      nomeUsuarioUnidade: this.dadosUnidade?.clienteNome,

      informacoesServicoSolicitado: dados.informacoesServicoSolicitado,
      servicoValores: dados.servicoValores,
      origem: this.origem,
    };

    const formData = new FormData();
    dados.anexos.forEach((anexo) => {
      formData.append('arquivos', anexo, anexo.name);
    });
    formData.append(
      'formAtendimento',
      new Blob([JSON.stringify(formulario)], { type: 'application/json' })
    );

    this.servicoService.postFormulario(formData).subscribe({
      next: ({ id, ano, hash }) => {
        this.loading = false;
        this.dadosSolicitacao = new IdentificacaoAtendimento(id, ano, hash);
        this.dadosUnidade = undefined;
        this.dadosSolicitante = undefined;
        this.ACTIVE_INDEX = 2;
      },
      error: (error) => {
        this.loading = false;
        if (error.error.message) {
          this.messageService.add({
            severity: 'error',
            detail: error.error.message,
          });
        }

        if (error.error.messages) {
          error.error.messages.forEach((message: any) => {
            this.messageService.add({
              severity: 'error',
              detail: message.message,
            });
          });
        }
      },
    });
  }
}
